import { createFileRoute, notFound } from '@tanstack/react-router';
import LipidGroup from '../../../../pages/lipidGroup/LipidGroup';
import { VIEW_INFERENCE_RESULTS_PAGE } from '../../../../utils/permissions';

export const Route = createFileRoute(
  '/_authenticated/_navbar/lipidgroup/$bondType'
)({
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(VIEW_INFERENCE_RESULTS_PAGE)) {
      throw notFound();
    }
  },
  component: LipidGroup,
});
